export default __webpack_public_path__ + "static/wms-integration-for-seamless-efficiency-d46ab6c0946793807fa19e7cdb6ca8ba.png";